import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedCollections: React.FC = () => {
  const collections = [
    {
      id: 'upholstery',
      name: 'Upholstery',
      description: 'Luxurious fabrics for furniture and interior design',
      image: '/images/Plain-Mini-Matt-Fabrics/imgi_221_MiniMatt_Colour07_Twist-Edit.jpg',
      category: 'Interior',
      gradient: 'from-royal-purple to-amethyst'
    },
    {
      id: 'apparel',
      name: 'Apparel',
      description: 'Premium fabrics for fashion and clothing',
      image: '/images/Online Clothing Fabrics Shop - Vega Textiles/imgi_149_IMG_1320.jpg',
      category: 'Fashion',
      gradient: 'from-warm-gold to-sunset-orange'
    },
    {
      id: 'technical',
      name: 'Technical Textiles',
      description: 'Innovative fabrics for specialized applications',
      image: '/images/The Stain Guard Range™️_ Protection🍷 – Ragland Fabrics/imgi_259_MarsalaTS.png',
      category: 'Industrial',
      gradient: 'from-ocean-blue to-teal-wave'
    }
  ];

  return (
    <section className="section-padding bg-gradient-secondary">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gradient-gold mb-6">
            Featured Collections
          </h2>
          <p className="text-xl text-sage max-w-3xl mx-auto">
            Discover our signature textile collections, each crafted with precision and passion.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {collections.map((collection, index) => (
            <div
              key={collection.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 border border-lavender/30"
            >
              <div className="relative overflow-hidden h-64">
                <img
                  src={collection.image}
                  alt={collection.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4">
                  <span className={`bg-gradient-to-r ${collection.gradient} text-white px-4 py-2 text-sm font-medium rounded-full shadow-lg`}>
                    {collection.category}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-midnight/60 via-deep-purple/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-serif font-semibold text-charcoal mb-4">
                  {collection.name}
                </h3>
                <p className="text-sage mb-6 leading-relaxed">
                  {collection.description}
                </p>
                <Link
                  to={`/collections#${collection.id}`}
                  className="inline-flex items-center text-royal-purple font-semibold hover:text-deep-purple transition-colors duration-200 group-hover:translate-x-1"
                >
                  Explore Collection
                  <svg className="w-5 h-5 ml-2 transition-transform duration-200 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/collections" className="btn-primary">
            View All Collections
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCollections;
